import { Col, Form, Tabs } from "@themesberg/react-bootstrap";
import styled from "styled-components";

const StyledSelect = styled(Form.Select)`
  option:first-child {
    display: none;
  }
`;

const CustomCol = styled(Col)`
  @media (max-width: 819px) {
    flex: 0 0 100%;
    max-width: 100%;
  }

  @media (min-width: 820px) and (max-width: 1045px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
`;

const DateInputWrapper = styled.div`
  .form-control {
    &::-webkit-calendar-picker-indicator {
      cursor: pointer;
      filter: invert(0.5);
    }
  }
`;

const StyledTabs = styled(Tabs)`
  border-bottom: 2px solid #ddd;
  margin-bottom: 20px;

  .nav-link {
    color: #555;
    font-weight: 600;
    border: none;
    border-bottom: 2px solid transparent;
    transition: all 0.3s ease;
    
    &:hover {
      color: #9155fd;
      border-color: transparent;
    }

    &.active {
      background-color: #9155fd !important;
      color: #fff !important;
      border-radius: 5px 5px 0 0;
    }
  }
`;

export { StyledSelect, CustomCol, DateInputWrapper, StyledTabs };
